import moment from "moment";
import cn from "classnames";
import React, { useMemo } from "react";
import { useIntl } from "react-intl";
import { ConversationNotification } from "../../../cores/notifications/interfaces/api/get-notifications";
import { getFirstLetters } from "../../utils/stringUtils";
import Avatar from "../Avatar";
import "./ConversationNotificationItem.scss";

interface Props {
  notification: ConversationNotification;
  variant?: "dropdown" | "page";
  isDarkMode?: boolean;
}

export default function ConversationNotificationItem({
  notification,
  variant = "dropdown",
  isDarkMode = false,
}: Props) {
  const intl = useIntl();

  const timeLine = useMemo(() => {
    const m = moment(notification.timestamp);
    if (!m.isValid()) return null;
    return `${m.format("DD MMM YYYY · HH:mm")} · ${m.fromNow()}`;
  }, [notification.timestamp]);

  if (variant === "page") {
    return (
      <div
        className={cn("conversation-notification-page", {
          "conversation-notification-page--dark": isDarkMode,
        })}
      >
        <Avatar
          label={getFirstLetters(notification.contact.name)}
          className="conversation-notification-page__avatar mr-0"
          width="48px"
          height="48px"
        />
        <div className="conversation-notification-page__body">
          <p className="conversation-notification-page__eyebrow">
            {intl.formatMessage({ id: "app.notifications.kind.conversation" })}
          </p>
          <p className="conversation-notification-page__title">
            {intl.formatMessage({ id: "app.notifications.newConversation" })}
          </p>
          <p className="conversation-notification-page__name">
            {notification.contact.name}
          </p>
          <p className="conversation-notification-page__email">
            {notification.contact.email}
          </p>
          {timeLine ? (
            <p className="conversation-notification-page__time">{timeLine}</p>
          ) : null}
        </div>
      </div>
    );
  }

  return (
    <div className="d-flex align-items-center border-bottom mb-1">
      <Avatar label={getFirstLetters(notification.contact.name)} className="mr-1" />
      <div className="d-flex flex-column overflow-hidden">
        <span>Nueva Conversación</span>
        <span className="text-truncate text-muted">
          {notification.contact.email}
        </span>
      </div>
    </div>
  );
}
